/**
 * External materials configuration for i18n
 * Supports 4 languages: pt (Portuguese), en (English), fr (French), es (Spanish)
 * 
 * PLACEHOLDER NOTICE:
 * Currently all URLs point to Portuguese materials.
 * Replace with language-specific URLs when translated materials are available.
 */

export const EXTERNAL_MATERIALS = {
  // Manual de Uso - First popup
  manualDeUso: {
    pt: "https://irisblobs.blob.core.windows.net/documentos-iris/Manual%20da%20Iris%20-%20BR%202.pdf?sp=r&st=2026-05-20T12:25:49Z&se=2031-02-01T20:40:49Z&sv=2026-02-06&sr=b&sig=%2FCibxVDsaFPDKZDsEAgzsILIbZy%2FuRSumgsxrdGhLYQ%3D",
    en: "https://irisblobs.blob.core.windows.net/documentos-iris/Manual%20da%20Iris%20-%20EN_V01.pdf?sp=r&st=2026-05-20T12:26:52Z&se=2031-02-01T20:41:52Z&sv=2026-02-06&sr=b&sig=Rm6HlDaUcfP6v6LKY9ghxoS0AIJsKoILK06MuXjJ2T4%3D", 
    fr: "https://irisblobs.blob.core.windows.net/documentos-iris/Manual%20da%20Iris%20-%20FRA_V01.pdf?sp=r&st=2026-05-20T12:28:33Z&se=2031-02-01T20:43:33Z&sv=2026-02-06&sr=b&sig=Is1PlUtnB9FxHRfTBTVCtJUddqyE9a6NgtHhLKLDqnw%3D", 
    es: "https://irisblobs.blob.core.windows.net/documentos-iris/Manual%20da%20Iris%20-%20ESP_V01.pdf?sp=r&st=2026-05-20T12:27:39Z&se=2031-03-01T20:42:39Z&sv=2026-02-06&sr=b&sig=LUg3r8bTAKNXb9OsVKf%2BZlNSfX9MGWaCuwftdkQCUa0%3D"  
  },

  // Tutoriais em vídeo - Last popup
  tutorialPlaylist: {
    pt: "https://www.youtube.com/playlist?list=PLf1q3zlcAd7K6BFBFfP0wDjyBXGdu6jCc",
    en: "https://www.youtube.com/playlist?list=PLf1q3zlcAd7K6BFBFfP0wDjyBXGdu6jCc", // TODO: Replace with English playlist
    fr: "https://www.youtube.com/playlist?list=PLf1q3zlcAd7K6BFBFfP0wDjyBXGdu6jCc", // TODO: Replace with French playlist
    es: "https://www.youtube.com/playlist?list=PLf1q3zlcAd7K6BFBFfP0wDjyBXGdu6jCc"  // TODO: Replace with Spanish playlist
  },

  // Guia de prompts - Last popup
  guiaPrompts: {
    pt: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20BR.pdf?sp=r&st=2026-05-20T12:20:27Z&se=2031-01-01T20:35:27Z&sv=2026-02-06&sr=b&sig=A3z3t4%2FKcRE5t1NtJI7RYfwL8qzCgtC4a0bNx76npJw%3D",
    en: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20EN.pdf?sp=r&st=2026-05-20T12:23:03Z&se=2031-02-01T20:38:03Z&sv=2026-02-06&sr=b&sig=Lg4tTBX%2Bt6cMt7CVminCFoSm53tqD3nGrIu%2FKycP0VQ%3D", 
    fr: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20FR.pdf?sp=r&st=2026-05-20T12:25:02Z&se=2031-02-01T20:40:02Z&sv=2026-02-06&sr=b&sig=r1N%2F4fWXhTw3PrLpVnDmeoj7GhyaQQ9re6E66YNgvDw%3D", 
    es: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20ESP.pdf?sp=r&st=2026-05-20T12:24:26Z&se=2031-02-01T20:39:26Z&sv=2026-02-06&sr=b&sig=eIqtldC9JgwG2DQcg94sg5sIo%2F09lj%2FMoHDkFG4ObFE%3D"  
  },

  // Guia de prompts - ChatBox e TestBox (info icon)
  guiaPromptsChatbox: {
    pt: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20BR.pdf?sp=r&st=2026-05-20T12:20:27Z&se=2031-01-01T20:35:27Z&sv=2026-02-06&sr=b&sig=A3z3t4%2FKcRE5t1NtJI7RYfwL8qzCgtC4a0bNx76npJw%3D",
    en: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20EN.pdf?sp=r&st=2026-05-20T12:23:03Z&se=2031-02-01T20:38:03Z&sv=2026-02-06&sr=b&sig=Lg4tTBX%2Bt6cMt7CVminCFoSm53tqD3nGrIu%2FKycP0VQ%3D", 
    fr: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20FR.pdf?sp=r&st=2026-05-20T12:25:02Z&se=2031-02-01T20:40:02Z&sv=2026-02-06&sr=b&sig=r1N%2F4fWXhTw3PrLpVnDmeoj7GhyaQQ9re6E66YNgvDw%3D", 
    es: "https://irisblobs.blob.core.windows.net/documentos-iris/Guia%20Prompt%20-%20ESP.pdf?sp=r&st=2026-05-20T12:24:26Z&se=2031-02-01T20:39:26Z&sv=2026-02-06&sr=b&sig=eIqtldC9JgwG2DQcg94sg5sIo%2F09lj%2FMoHDkFG4ObFE%3D"  
  },

  // Suporte - Last popup (Forms de sugestão)
  supportForm: {
    pt: "https://forms.office.com/r/RCVS4JTQS4",
    en: "https://forms.office.com/r/RCVS4JTQS4", // TODO: Replace with English form
    fr: "https://forms.office.com/r/RCVS4JTQS4", // TODO: Replace with French form
    es: "https://forms.office.com/r/RCVS4JTQS4"  // TODO: Replace with Spanish form
  },

  // Solicitar assistente - Hub (Request Assistant)
  requestAssistantForm: {
    pt: "https://forms.office.com/r/hCF8VJSpjX",
    en: "https://forms.office.com/r/hCF8VJSpjX", // TODO: Replace with English form
    fr: "https://forms.office.com/r/hCF8VJSpjX", // TODO: Replace with French form
    es: "https://forms.office.com/r/hCF8VJSpjX"  // TODO: Replace with Spanish form
  },

  // Formulário de sugestão - Hub (Lamp icon)
  suggestionForm: {
    pt: "https://forms.office.com/r/RCVS4JTQS4",
    en: "https://forms.office.com/r/RCVS4JTQS4", // TODO: Replace with English form
    fr: "https://forms.office.com/r/RCVS4JTQS4", // TODO: Replace with French form
    es: "https://forms.office.com/r/RCVS4JTQS4"  // TODO: Replace with Spanish form
  }
};

/**
 * Get material URL based on current language
 * @param {string} materialKey - Key from EXTERNAL_MATERIALS object
 * @param {string} language - Current language (e.g., 'pt', 'en-US', 'fr')
 * @returns {string} URL for the material in the specified language
 */
export const getMaterialUrl = (materialKey, language) => {
  const lang = language.split('-')[0]; // Normalize 'en-US' to 'en'
  const material = EXTERNAL_MATERIALS[materialKey];
  
  if (!material) {
    console.warn(`Material key "${materialKey}" not found in EXTERNAL_MATERIALS`);
    return '';
  }
  
  // Fallback to Portuguese if language not found
  return material[lang] || material.pt;
};
